<template>
  <div class="crm">
    <page-header
      title="Dispatch Management"
      breadcrumb="Dashboard > Operations > Dispatch Management "
    />
    <div class="">
      <div class="flex justify-between my-4 pt-8 border-b-2 border-[#B7BDCD]">
        <div class="flex">
          <div
            :class="{ active: currentTab == 'outgoing' }"
            class="tab-item"
            @click="currentTab = 'outgoing'"
          >
            <p>Outgoing</p>
          </div>
          <div
            :class="{ active: currentTab == 'incoming' }"
            class="tab-item"
            @click="currentTab = 'incoming'"
          >
            <p>Incoming</p>
          </div>
          <div
            :class="{ active: currentTab == 'completed' }"
            class="tab-item"
            @click="currentTab = 'completed'"
          >
            <p>Completed</p>
          </div>
        </div>
      </div>
      <pre>
      </pre>
      <div class="topline-wrapper px-2 py-2 ">
        <div class="topline px-3 flex flex-wrap justify-start">
          <div class="flex gap-2 topline-child">
            <CummulativeIcon />
            <p class="mt-2 font-bold">Cummulative</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">SHIPMENTS (QTY)</p>

            <p class="topline-value">{{ dispatchAnalytics.totalDispatchCount }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">DISPATCHES (M)</p>
            <p class="topline-value">{{ dispatchAnalytics.totalDispatchDistance }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">GROSS WEIGHT(KG)</p>
            <p class="topline-value">{{ dispatchAnalytics.totalDispatchWeight }}</p>
          </div>

          <div class="topline-child">
            <p class="topline-header">Volume</p>
            <p class="topline-value">{{ dispatchAnalytics.totalDispatchVolume }}</p>
          </div>
        </div>

        <div class="topline px-3 flex flex-wrap justify-start">
          <div class="flex gap-2 topline-child">
            <TopRoutesIcon />
            <p class="mt-2 font-bold">Top Routes</p>
          </div>

          <div class="topline-child" v-for="(shippingservice, index) in dispatchAnalytics.topRoutes.slice(0,4)" :key="index">
              <p class="topline-header">{{ shippingservice.routeName }} (QTY)</p>
              <p class="topline-value">{{ shippingservice.totalShipments ? shippingservice.totalShipments : 0 }}</p>
          </div>

        </div>
      </div>

      <div class="flex justify-end mt-12 mb-8">
          <button class="mr-4 px-5 rounded-md font-bold text-white pale-blue" @click="$router.push({ name : 'Requests'})">All Requests</button>
      </div>
      <dispatch-table class="mt-5" :currentTab="currentTab" />
      
      
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import DispatchTable from "./DispatchTable";
import CummulativeIcon from "@/components/UI/svgs/CummulativeIcon.vue"
import TopRoutesIcon from "@/components/UI/svgs/TopRoutesIcon.vue"

export default {
  components: {
    PageHeader,
    DispatchTable,
    CummulativeIcon,
    TopRoutesIcon
  },
  data() {
    return {
      currentTab: "outgoing",
      dispatches : [],
      loadingDispatches : true,
      dispatchAnalytics : {}
    };
  },
  
  created(){
  },
  watch : {
    
  },
  mounted(){
    this.getAnalytics();
  },
  methods : {
    async getAnalytics(){
      try {
        this.loading = true;
        const { data: response } = await this.$_getDispatchToplineAnalytics();

        console.log(response)

        this.dispatchAnalytics = response.data
        
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-date-editor.el-input {
  margin-bottom: 0;
}
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}

.topline-wrapper{
  border:1px solid gray;
  border-style: dashed;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 10px;
  background-color: white;
  box-sizing: content-box;
  box-shadow: 10px 10px 30px rgb(227, 224, 224);

  .topline{
    background-color: #F2F7FC;
    border-radius:10px ;
    margin-top: 7px;
    min-height: 72px;
    padding-top: 16px;
    padding-bottom: 16px;
    vertical-align: middle;

    .topline-child{
      border-right: 1px dashed #4142455C;
      min-height: 40px;
      padding:0px 20px 10px 20px;
      width: 20%;

      .topline-header{
        color:#7A90A7;
        font-weight: 600;
        font-size: 14px;
      }

      .topline-value{
        color: #10233E;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
} 

.pale-blue {
  background-color: #10233e;
  height: 40px;
}
</style>
